export type AvailableLanguage = {
  code: string;
  name: string;
  language: string;
  flag: string;
  redirection?: string;
};

export const AVAILABLE_LANGUAGES: AvailableLanguage[] = [
  { code: "fr-FR", language: "fr", name: "Français", flag: "/flags/fr.svg" },
  { code: "en-US", language: "en", name: "English", flag: "/flags/en.svg" },
  { code: "de-DE", language: "de", name: "Deutsch", flag: "/flags/de.svg" },
  { code: "it-IT", language: "it", name: "Italiano", flag: "/flags/it.svg" },
  { code: "es-ES", language: "es", name: "Spanish", flag: "/flags/es.svg" },
  { code: "nl-NL", language: "nl", name: "Nederlands", flag: "/flags/en.svg" },
  { code: "ro-RO", language: "ro", name: "Romanian", flag: "/flags/en.svg" },
  { code: "cs-CZ", language: "cs", name: "Czech", flag: "/flags/en.svg" },
  { code: "da-DK", language: "da", name: "Danish", flag: "/flags/en.svg" },
  { code: "fi-FI", language: "fi", name: "Finnish", flag: "/flags/en.svg" },
  { code: "el-GR", language: "el", name: "Greek", flag: "/flags/en.svg" },
  { code: "lv-LV", language: "lv", name: "Latvian", flag: "/flags/en.svg" },
  { code: "sv-SE", language: "sv", name: "Swedish", flag: "/flags/en.svg" },
  { code: "no-NO", language: "no", name: "Norwegian", flag: "/flags/en.svg" },
  { code: "pl-PL", language: "pl", name: "Polish", flag: "/flags/en.svg" },
  { code: "ko-KR", language: "ko", name: "Korean", flag: "/flags/en.svg" },
  { code: "ja-JP", language: "ja", name: "Japanese", flag: "/flags/en.svg" },
  {
    code: "pt-BR",
    language: "pt",
    name: "Portuguese (Brazil)",
    flag: "/flags/en.svg",
  },
  {
    code: "pt-PT",
    language: "pt",
    name: "Portuguese (Portugal)",
    flag: "/flags/en.svg",
  },
  {
    code: "zh-Hans",
    language: "zh",
    name: "Chinese (Simplified)",
    flag: "/flags/en.svg",
  },
  {
    code: "zh-Hant",
    language: "zh",
    name: "Chinese (Traditional)",
    flag: "/flags/en.svg",
  },
  {
    code: "en-GB",
    language: "en",
    name: "English",
    flag: "/flags/en.svg",
    redirection: "en-US",
  },
];
